import jwt_decode from 'jwt-decode'
import request from '@/lib/request'
import { ACCESS_TOKEN_KEY } from '@/lib/constants'
import { AuthError } from '@/lib/custom_error'

var is_logged_in = false;

const wasteSessionDataAll = function () {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem('pharm_id');
  localStorage.removeItem('debug');
}

const writeSessionData = function (token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token); // localstorage 저장하기
  const decoded_token = jwt_decode(token)
  localStorage.setItem('pharm_id', decoded_token.pharm_id); // localstorage 저장하기
  localStorage.setItem('debug', JSON.stringify(decoded_token)) // Todo: 이거 mdsqr껄로 안써도 되나?
}

const login = async function (email, password) {

  let {data} = await request.post('/auth/dr/pharm', { 'email': email, 'pass': password });
  let {resp} = data

  if (data.status !== 200) {
    wasteSessionDataAll()
    throw new AuthError(data.msg, data.status)
  }

  // console.log('resp', resp)

  writeSessionData(data.resp.token)
  return data;
}

const login_verify = async function (login_info) {

  let {data} = await request.post('/auth/dr_check/pharm', login_info);
  let {resp} = data

  return data;
}

const user_login = async function (login_info) {

  // console.log('login_info', login_info)

  let {data} = await request.post('/auth/dr/pharm', login_info);
  let {resp} = data

  if (data.status !== 200) {
    wasteSessionDataAll()
    throw new AuthError(data.msg, data.status)
  }

  // console.log('resp', resp)

  writeSessionData(data.resp.token)
  return data;
}

const logout = async function () {
  
  let pharm_id = localStorage.getItem('pharm_id');
  let {data} = await request.post('/auth/logout', { 'user_id': pharm_id, 'uuid': pharm_id, 'acct_type': 3, 'auth_type': 1, 'log_type': 'logout' });
  //let {resp} = data
  //console.log('resp', resp)

  await wasteSessionDataAll()
}

const getAuthInfo = function (key) {
  if (key) { // 특정키만 반환한다.
    const value = localStorage.getItem(key)
    if (!value) throw new Error(`로컬 스토리지에서 ${key} 값 가져오기를 실패하였습니다.`)
    return value
  }
  const access_token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (access_token) {
    return jwt_decode(access_token)
  } else {
    return false
  }
}

const isLoggedIn = function () {

  let token_string = localStorage.getItem(ACCESS_TOKEN_KEY);

  if (token_string) {
    return true;
  }

  // console.log('로그인안되있음');
  return false;
}

export default { login, isLoggedIn, logout, getAuthInfo, user_login, login_verify}
